import {
  AlertTriangle,
  CalendarClock,
  CheckCircle2,
  ReceiptText,
  RefreshCw,
  Wifi,
} from "lucide-react";
import { getStatusClasses, getSubscriptionInfo } from "../utils/subscription";

export default function SubscriptionStatusCard({
  usuario,
  loading = false,
  onRenew,
  onReceipts,
  compact = false,
}) {
  const info = getSubscriptionInfo(usuario || {});
  const badgeClasses = getStatusClasses(info.statusTone);
  const StatusIcon = info.isActive ? CheckCircle2 : AlertTriangle;

  return (
    <section className="w-full overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm">
      <div className="flex flex-col gap-4 border-b border-slate-100 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-blue-50 text-blue-600">
            <Wifi size={24} />
          </div>
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-500">
              Subscricao actual
            </p>
            <h2 className="text-lg font-semibold text-slate-900">
              {loading ? "A carregar..." : info.planLabel}
            </h2>
          </div>
        </div>

        <span
          className={`inline-flex w-fit items-center gap-2 rounded-md border px-3 py-1 text-sm font-semibold ${badgeClasses}`}
        >
          <StatusIcon size={16} />
          {loading ? "A confirmar" : info.statusLabel}
        </span>
      </div>

      <div className="grid gap-4 p-4 sm:grid-cols-3">
        <div>
          <p className="text-xs text-slate-500">Periodo</p>
          <p className="mt-1 font-semibold text-slate-800">{info.periodLabel}</p>
        </div>
        <div>
          <p className="text-xs text-slate-500">Mensalidade</p>
          <p className="mt-1 font-semibold text-slate-800">{info.priceLabel}</p>
        </div>
        <div>
          <p className="text-xs text-slate-500">Proxima expiracao</p>
          <p className="mt-1 font-semibold text-slate-800">{info.expiryLabel}</p>
        </div>
      </div>

      {!compact && info.shouldRenewSoon && (
        <div className="mx-4 mb-4 flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700">
          <CalendarClock size={18} />
          A subscricao termina em {info.daysLabel}. Renovar agora evita corte.
        </div>
      )}

      {!compact && (
        <div className="flex flex-col gap-2 border-t border-slate-100 p-4 sm:flex-row">
          <button
            type="button"
            onClick={onRenew}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-500"
          >
            <RefreshCw size={17} />
            Renovar plano
          </button>
          <button
            type="button"
            onClick={onReceipts}
            className="inline-flex items-center justify-center gap-2 rounded-md border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            <ReceiptText size={17} />
            Ver recibos
          </button>
        </div>
      )}
    </section>
  );
}
